module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('main', {
    staticClass: "main main--request request"
  }, [_c('div', {
    staticClass: "gradient-bg"
  }), _vm._v(" "), _c('module-spinner', {
    attrs: {
      "active": !_vm.loaded,
      "floating": true
    }
  }), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loaded),
      expression: "loaded"
    }],
    staticClass: "group mt request__wrapper"
  }, [_c('div', {
    staticClass: "request__heading"
  }, [(_vm.getContent("title")) ? _c('h3', {
    staticClass: "h3"
  }, [_vm._v(_vm._s(_vm.getContent("title")))]) : _vm._e(), _vm._v(" "), (_vm.getContent("intro")) ? _c('p', {
    staticClass: "p"
  }, [_vm._v(_vm._s(_vm.getContent("intro")))]) : _vm._e(), _vm._v(" "), (typeof _vm.getContent("intro-continued") === 'string') ? _c('p', {
    staticClass: "p"
  }, [_vm._v(_vm._s(_vm.getContent("intro-continued")))]) : _vm._e()]), _vm._v(" "), (_vm.requestState === "doctor-complete") ? _c('module-detail-list', {
    attrs: {
      "items": {
        'Patient Name': _vm.patient.full_name,
        'Procedure Type': _vm.reviewNomenclatureBySlugAndId("procedure", _vm.currentRequest.procedure),
        'Procedure Date': _vm.currentRequest.most_recent_procedure ? 'Patient’s most recent procedure' : _vm.currentRequest.date_of_procedure,
      }
    }
  }) : _vm._e(), _vm._v(" "), _c('module-form', {
    staticClass: "request-form",
    attrs: {
      "button": "primary",
      "form-id": "request-form",
      "fields": _vm.fields,
      "action": _vm.action,
      "success": _vm.success,
      "fail": _vm.fail
    }
  })], 1)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-743b55e9"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./client/views/Request.vue
// module id = 366
// module chunks = 0